export enum TimePeriodExclusionEnum {
  TWENTY_FOUR_HOURS = '24Hours',
  SEVEN_DAYS = '7Days',
  THIRTY_DAYS = '30Days',
  THREE_MONTHS = '3Months',
  SIX_MONTHS = '6Months',
  SPECIFIC_DATE = 'specificDate',
  PERMANENTLY = 'permanently',
}
